var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-btn',{on:{"click":_vm.goBack}},[_vm._v(" Zpět ")]),_c('v-row',[_c('v-col',{staticClass:"text-h1",staticStyle:{"display":"flex","justify-content":"center"},attrs:{"cols":"12"}},[_vm._v(" 403 ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }